// Campus photo for /colleges/rutgers-university-camden: CC BY-SA 3.0, by Hudconja, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3A330CooperStRutgersCamden.JPG), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/rutgers-university-camden/; credited under the photo.
const photo = {
    "slug": "rutgers-university-camden",
    "alt": "The 330 Cooper Street student housing building at Rutgers University-Camden in Camden, New Jersey",
    "src": "/colleges/rutgers-university-camden/campus-1600.webp",
    "srcSmall": "/colleges/rutgers-university-camden/campus-800.webp",
    "srcMid": "/colleges/rutgers-university-camden/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/rutgers-university-camden/og.jpg",
    "title": "330CooperStRutgersCamden",
    "author": "Hudconja",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3A330CooperStRutgersCamden.JPG",
    "read": "2026-10-02"
};

export default photo;
